import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import React from 'react';
import { Link } from 'react-router-dom';

import isAuthenticated from '../../../../../utils/authUtils';
import { getIDTokenData } from '../../../../../utils/tokenUtils';
import { BrandedLogo } from '../../../../common/BrandedLogo/BrandedLogo';
import { HamburgerMenu } from '../HamburgerMenu';
import SignUp from '../SignUp';

import { ThemeSelector } from './themeSelector/ThemeSelector';

export function HeaderMenuSmall() {
  const theme = useTheme();

  const getTopMenuItem = () => {
    const idToken = getIDTokenData();

    if (JSON.stringify(idToken).length <= 2) {
      return <SignUp size={'small'} />;
    }

    return (
      <>
        <ThemeSelector />
        <Divider orientation="vertical" flexItem />
        <HamburgerMenu />
      </>
    );
  };

  return (
    <Box
      className={`header-menu-small-wrapper`}
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        color: theme.palette.mode === 'dark' ? theme.palette.text.primary : '#0f172a',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'left',
          flex: 1,
          minWidth: 0,
          overflow: 'hidden',
        }}
      >
        <Link to={isAuthenticated() ? '/Dashboard' : '/'} style={{ textDecoration: 'none' }}>
          <BrandedLogo height={35} width={80} />
        </Link>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'right',
          flexShrink: 0,
          gap: theme.spacing(1.5),
        }}
      >
        {getTopMenuItem()}
      </Box>
    </Box>
  );
}
